// Helpers to open WhatsApp using the installed desktop/mobile app or
// the web version, depending on a per-user preference saved in
// localStorage under the key `whatsapp_open_mode`:
//   - "app" (default): uses the `whatsapp://send` protocol, which the
//     installed WhatsApp Desktop registers on install. The OS opens the
//     app directly without leaving a blank tab open.
//   - "web": uses `https://wa.me/...`, which opens web.whatsapp.com or
//     prompts to install. Useful on machines without the desktop app.

const STORAGE_KEY = "whatsapp_open_mode";

export function getWhatsAppOpenMode() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === "web" ? "web" : "app";
  } catch (e) {
    return "app";
  }
}

export function setWhatsAppOpenMode(mode) {
  try {
    localStorage.setItem(STORAGE_KEY, mode === "web" ? "web" : "app");
  } catch (e) { /* ignore */ }
}

// Build a WhatsApp deep-link.
// - phoneNumber may be empty (opens the app's chat picker)
// - phoneNumber for Costa Rica: 8 digits → we prepend "506".
//   If already starts with "506" or any country code, leave it.
export function buildWhatsAppLink(phoneNumber, text, mode) {
  const resolvedMode = mode || getWhatsAppOpenMode();
  const encoded = text ? encodeURIComponent(text) : "";
  const cleaned = (phoneNumber || "").toString().replace(/\D/g, "");
  let phone = cleaned;
  if (cleaned && cleaned.length === 8) {
    phone = "506" + cleaned;
  }

  if (resolvedMode === "web") {
    if (phone) {
      return `https://wa.me/${phone}${encoded ? `?text=${encoded}` : ""}`;
    }
    return `https://wa.me/${encoded ? `?text=${encoded}` : ""}`;
  }

  // app mode (default)
  if (phone) {
    return `whatsapp://send?phone=${phone}${encoded ? `&text=${encoded}` : ""}`;
  }
  return `whatsapp://send${encoded ? `?text=${encoded}` : ""}`;
}

// Open WhatsApp using the chosen mode.
// - app mode: assigns to `window.location.href` so the OS handler takes over
//   without leaving an empty tab behind.
// - web mode: opens a new tab as before.
export function openWhatsApp(phoneNumber, text) {
  const mode = getWhatsAppOpenMode();
  const url = buildWhatsAppLink(phoneNumber, text, mode);
  if (mode === "web") {
    window.open(url, "_blank", "noopener,noreferrer");
  } else {
    window.location.href = url;
  }
}

